import {
  OZOW_API_URL,
  OZOW_API_PROD_URL,
  OZOW_API_TDM_PROD_URL,
} from "src/constants";
import { getSafeApiUrl } from "./urlValidator";

/**
 * Gets API URL from URL parameters
 * @returns API URL from whitelist or null if not found
 */
export const getApiUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const apiUrlFromParams = urlParams.get("apiUrl");
  return getSafeApiUrl(apiUrlFromParams);
};

/**
 * Gets Ozow API URL based on main apiUrl parameter.
 * @returns Ozow API URL for the current environment
 */
export const getOzowApiUrl = (): string => {
  const apiUrl = getApiUrl();
  if (!apiUrl) {
    return OZOW_API_URL;
  }
  if (apiUrl.includes("tdmarkets.io")) {
    return OZOW_API_TDM_PROD_URL;
  }
  const isDev = apiUrl.includes("dev") || apiUrl.includes("uat");
  return isDev ? OZOW_API_URL : OZOW_API_PROD_URL;
};
